"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var composeStore_1 = require("owa-mail-compose-store/lib/store/composeStore");
var owa_mail_feature_flags_1 = require("owa-mail-feature-flags");
exports.default = {
    MailComposeNew: {
        datapoint: {
            name: 'MailComposeNew',
            options: { isQos: true },
            customData: function (actionSource) { return [
                actionSource,
                !owa_mail_feature_flags_1.isMailFeatureEnabled('rp-tabView') && !!composeStore_1.getStore().defaultViewState,
            ]; },
        },
    },
    MailComposeFromHeader: { datapoint: { name: 'MailComposeFromHeader' } },
};
//# sourceMappingURL=datapoints.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/mail/orchestration/owa-mail-message-actions/lib/datapoints.js
// module id = 1709
// module chunks = 4 46 93 105 108